import React, {useEffect, useState} from "react";
import style from "../documentConfig/newDocument.module.css";
import {ErrorToast, SuccessToast} from "../../components/toastMessage";
import {BASE_URL} from "../../constants/Constants";
import {useLocation, useNavigate} from "react-router-dom";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import {_axios} from "../../utils/axios";

const NewDocument = () => {
    const {state} = useLocation();
    const documentData = state?.documentData;
    const navigate = useNavigate();
    const [isApplicationDocument, setIsApplicationDocument] = useState(false);
    const [isInitiallyApplicationDocument, setIsInitiallyApplicationDocument] = useState(false);
    const [initialDocumentType, setInitialDocumentType] = useState(documentData?.document_Type ?? "0");
    const [documentType, setDocumentType] = useState([])
    const [formData, setFormData] = useState({
        document_config_id: documentData?.document_config_id ?? null,
        document_label: documentData?.document_label ?? "",
        document_label_mr: documentData?.document_label_mr ?? '',
        document_label_hi: documentData?.document_label_hi ?? '',
        active: documentData?.active === 1 ?? false,
        document_name: documentData?.document_name ?? "",
        document_Type: documentData?.document_Type ?? "0",
        file_size: documentData?.file_size ?? "",
        file_size_unit: documentData?.file_size_unit ?? 'KB',
        mandatory: documentData?.mandatory === 1 ?? false,
        file_type: documentData?.file_type ?? '',
        Req_digital_Sign: documentData?.Req_digital_Sign === 1 ?? false,
    });

    const handleInputChange = (e: { target: { name: string; value: string | boolean; }; }) => {
        const {name, value} = e.target;
        setFormData((prevData) => {
            if (name === "document_Type") {
                setIsApplicationDocument(value === "Application Document");
                // Reset Req_digital_Sign when changing from Application Document to another type
                if (prevData.document_Type === "Application Document" && value !== "Application Document") {
                    return {
                        ...prevData,
                        [name]: value,
                        Req_digital_Sign: false,
                    };
                }
            }
            return {
                ...prevData,
                [name]: value,
            };
        });
    };

    const handleFileTypeChange = (fileExtension: string) => {

        const fileTypes = formData.file_type.split(',');
        console.log('fileTypes', fileTypes, fileTypes.includes(fileExtension))
        if (fileTypes.includes(fileExtension)) {
            // Remove file extension
            fileTypes.splice(fileTypes.indexOf(fileExtension), 1);
            formData.file_type = fileTypes.join(',');
        } else {
            // Add file extension
            formData.file_type = `${formData.file_type},${fileExtension}`;
        }
        console.log('formData.file_type', formData.file_type)
        setFormData({...formData});
    };

    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        // Handle form submission logic here, such as sending data to a server.
    };

    const getDocumentType = () => {
        _axios.get(`${BASE_URL}/api/document-config/types`)
            .then(function (response) {
                console.log('response', response);
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                const filteredData = response?.data?.data.filter(
                    (type: { document_type_name: string; }) => type?.document_type_name !== "NOC"
                );
                setDocumentType(filteredData);
            })
            .catch(function (error) {
                // handle error
                if (error?.response?.data?.message) {
                    ErrorToast(error?.response?.data?.message)
                }
                console.log('error', error);
            })

    }

    useEffect(() => {
        getDocumentType();
        setInitialDocumentType(formData.document_Type);
        setIsApplicationDocument(formData.document_Type === "Application Document");
    }, []);

    useEffect(() => {
        getDocumentType();

        setFormData((prevData) => ({
            ...prevData,
            Req_digital_Sign:
                prevData.document_Type === "Application Document"
                    ? prevData.Req_digital_Sign
                    : false,
        }));

        // Set isApplicationDocument based on initial value of formData.document_Type
        setIsApplicationDocument(formData.document_Type === "Application Document");
    }, [])

    const onSubmit = () => {

        if (formData.document_label.length === 0 ||
            formData.document_label_mr.length === 0 ||
            formData.document_label_hi.length === 0) {
            ErrorToast("Please enter valid Document Label")
            return
        }
        if (formData.document_name.length === 0) {
            ErrorToast("Please enter valid Document Name")
            return
        }
        if (
            formData.document_Type.length === 0 ||
            formData.document_Type === "0"
        ) {
            ErrorToast("Please select a valid Document Type");
            return;
        }
        if (formData.file_size.length === 0) {
            ErrorToast("Please enter valid file size for Document")
            return
        }
        const data = {
            document_label: formData.document_label,
            document_label_mr: formData.document_label_mr,
            document_label_hi: formData.document_label_hi,
            document_name: formData.document_name,
            document_Type: formData.document_Type,
            file_type: formData.file_type,
            file_size: formData.file_size,
            file_size_unit: formData.file_size_unit,
            mandatory: formData.mandatory ? 1 : 0,
            active: formData.active ? 1 : 0,
            Req_digital_Sign: formData.Req_digital_Sign ? 1 : 0,
        }

        if (documentData !== undefined) {
            _axios.patch(`${BASE_URL}/api/document-config`, {
                ...data,
                document_config_id: documentData?.document_config_id
            })
                .then(function (response) {
                    console.log('response', response);
                    if (response?.data?.success === 0) {
                        ErrorToast(response?.data?.message)
                        return
                    }
                    SuccessToast('Document Config Updated')
                    navigate('/document-config', {state: {tab: 1}});

                    // handle success

                })
                .catch(function (error) {
                    // handle error
                    if (error?.response?.data?.message) {
                        ErrorToast(error?.response?.data?.message)
                    }
                    console.log('error', error);
                })
        } else {
            _axios.post(`${BASE_URL}/api/document-config`, data)
                .then(function (response) {
                    console.log('response', response);
                    if (response?.data?.success === 0) {
                        ErrorToast(response?.data?.message)
                        return
                    }
                    SuccessToast('Document Config Added')
                    navigate('/document-config', {state: {tab: 1}});

                    // handle success

                })
                .catch(function (error) {
                    // handle error
                    if (error?.response?.data?.message) {
                        ErrorToast(error?.response?.data?.message)
                    }
                    console.log('error', error);
                })
        }
    }

    useEffect(() => {
        if (documentData) {
            setFormData((prevData) => ({
                ...prevData,
                document_config_id: documentData.document_config_id
            }));
        }
    }, [documentData]);

    useEffect(() => {
        if (documentData) {
            console.log("Document Config ID:", documentData.document_config_id); // Add this to verify the value
        }
    }, [documentData]);

    return (
        <div className={style.body}>
            <div className={style.divbodyheading}>
                <p className={style.bodytitle}>{documentData ? 'Edit' : 'Create'} Document</p>
            </div>
            <form onSubmit={handleSubmit}>
                <BoxComponent>
                    <div className={style.navbar}>
                        <div className={style.userform}>
                            <div className={style.formrow}>
                                <div className={style.formgroup}>
                                    <div className={style.loginText}>Document Label <span
                                        className="text-red-500">{' *'}</span></div>
                                    <input
                                        type="text"
                                        id="name"
                                        name="document_label"
                                        placeholder="Document Label"
                                        value={formData.document_label}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className={style.formgroup}>
                                    <div className={style.footerActive}>
                                        <label className={style.footerAct}>Activate</label>
                                        <div className={style.footerAct}>
                                            <label className={style.toggleBtn}>
                                                <input type="checkbox" checked={formData.active}
                                                       onClick={() => handleInputChange({
                                                           target: {
                                                               name: 'active',
                                                               value: !formData.active
                                                           }
                                                       })} className={style.inputCheckbox}/>
                                                <span className={style.slider}></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={style.formrow}>
                                <div className={style.formgroup}>
                                    <div className={style.loginText}>Document Label Marathi<span
                                        className="text-red-500">{' *'}</span></div>
                                    <input
                                        type="text"
                                        id="name"
                                        name="document_label_mr"
                                        placeholder="Document Label"
                                        value={formData.document_label_mr}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className={style.formgroup}>
                                    <div className={style.loginText}>Document Label Hindi<span
                                        className="text-red-500">{' *'}</span></div>
                                    <input
                                        type="text"
                                        id="name"
                                        name="document_label_hi"
                                        placeholder="Document Label"
                                        value={formData.document_label_hi}
                                        onChange={handleInputChange}
                                    />
                                </div>

                            </div>

                            <div className={style.formrow}>
                                <div className={style.formgroup}>
                                    <div className={style.loginText}>Document Name<span
                                        className="text-red-500">{' *'}</span></div>
                                    <input
                                        type="text"
                                        id="documentName"
                                        name="document_name"
                                        placeholder="Document Name"
                                        disabled={documentData !== undefined}
                                        style={{backgroundColor: documentData !== undefined ? '#c5c5c5' : 'white'}}
                                        value={formData.document_name}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className={style.formgroup}>
                                    <div className={style.loginText}>Document Type<span
                                        className="text-red-500">{' *'}</span></div>
                                    <select
                                        id="documentType"
                                        name="document_Type"
                                        className="selectwhite"
                                        value={formData.document_Type}
                                        disabled={documentData !== undefined}
                                        style={{backgroundColor: documentData !== undefined ? '#c5c5c5' : 'white'}}
                                        onChange={handleInputChange}
                                    >
                                        <option value="0" disabled>Select Document Type</option>
                                        {documentType?.map((type: any) => (
                                            <option value={type?.document_type_name}>{type?.document_type_name}</option>
                                        ))}
                                    </select>
                                </div>

                            </div>

                            <div className={style.formrow} style={{paddingTop: "2%"}}>
                                <div className={style.formgroup}>
                                    <label htmlFor="fileType" className={style.fileType}>
                                        File Type
                                    </label>

                                </div>

                                <div className={style.formgroup}>
                                    <label className={style.container}>PNG
                                        <input
                                            type="checkbox"
                                            id="fileType"
                                            name="isSelected"
                                            checked={formData.file_type.includes('png')}
                                            onChange={() => handleFileTypeChange('png')}
                                        />
                                        <span className={style.checkmark}></span>
                                    </label>
                                </div>

                                <div className={style.formgroup}>
                                    <label className={style.container}>JPG
                                        <input
                                            type="checkbox"
                                            id="fileType"
                                            name="isSelected"
                                            checked={formData.file_type.includes('jpg')}
                                            onChange={() => handleFileTypeChange('jpg')}
                                        />
                                        <span className={style.checkmark}></span>
                                    </label>
                                </div>

                                <div className={style.formgroup}>
                                    <label className={style.container}>PDF
                                        <input
                                            type="checkbox"
                                            id="fileType"
                                            name="isSelected"
                                            checked={formData.file_type.includes('pdf')}
                                            onChange={() => handleFileTypeChange('pdf')}
                                        />
                                        <span className={style.checkmark}></span>
                                    </label>
                                </div>

                                <div className={style.formgroup}>
                                    <label className={style.container}>DOC
                                        <input
                                            type="checkbox"
                                            id="fileType"
                                            name="isSelected"
                                            checked={formData.file_type.includes('doc')}
                                            onChange={() => handleFileTypeChange('doc')}
                                        />
                                        <span className={style.checkmark}></span>
                                    </label>
                                </div>
                            </div>

                            <div className={style.formrow} style={{paddingTop: "2%"}}>
                                <div className={style.formgroup}>
                                    <div className={style.loginText}>File Size<span
                                        className="text-red-500">{' *'}</span></div>
                                    <input
                                        // type="text"
                                        type="number"
                                        id="fileSize"
                                        name="file_size"
                                        placeholder="File Size"
                                        value={formData.file_size}
                                        onChange={handleInputChange}
                                        min="0" // to prevent negative numbers
                                        className={style.fileSizeCss}
                                    />
                                </div>

                                <div className={style.formgroup}>
                                    <label className={style.radio}>KB
                                        <input
                                            type="radio"
                                            id="fileType"
                                            name="isFileSize"
                                            checked={formData.file_size_unit === 'KB'}
                                            onChange={() => handleInputChange({
                                                target: {
                                                    name: 'file_size_unit',
                                                    value: 'KB'
                                                }
                                            })}
                                        />
                                        <span className={style.checkmarkRadio}></span>
                                    </label>
                                </div>

                                <div className={style.formgroup}>
                                    <label className={style.radio}>MB
                                        <input
                                            type="radio"
                                            id="fileType"
                                            name="file_size_unit"
                                            checked={formData.file_size_unit === 'MB'}
                                            onChange={() => handleInputChange({
                                                target: {
                                                    name: 'file_size_unit',
                                                    value: 'MB'
                                                }
                                            })}
                                        />
                                        <span className={style.checkmarkRadio}></span>
                                    </label>
                                </div>

                                {formData?.document_config_id !== 1 && formData?.document_config_id !== 2 &&
                                    <div className={style.formgroup}>
                                        <div className={style.footerActive}>
                                            <label className={style.footerAct}>Mandatory</label>
                                            <div className={style.footerAct}>
                                                <label className={style.toggleBtn}>
                                                    <input type="checkbox" checked={formData.mandatory}
                                                           onClick={() => handleInputChange({
                                                               target: {
                                                                   name: 'mandatory',
                                                                   value: !formData.mandatory
                                                               }
                                                           })} className={style.inputCheckbox}/>
                                                    <span className={style.slider}></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>}
                            </div>

                            <div className={style.formgroup}>
                                <label
                                    className={`${style.container} ${!isApplicationDocument ? style.disabledLabel : ""
                                    }`}
                                >
                                    Required for Digital Signature
                                    <input
                                        type="checkbox"
                                        id="Req_digital_Sign"
                                        name="Req_digital_Sign"
                                        checked={isApplicationDocument && formData.Req_digital_Sign}
                                        onChange={() =>
                                            handleInputChange({
                                                target: {
                                                    name: "Req_digital_Sign",
                                                    value: !formData.Req_digital_Sign,
                                                },
                                            })
                                        }
                                        disabled={!isApplicationDocument}
                                        className={!isApplicationDocument ? style.disabledCheckbox : ""}
                                    />
                                    <span
                                        className={`${style.checkmark} ${!isApplicationDocument ? style.disabledCheckbox : ""
                                        }`}
                                    ></span>
                                </label>
                            </div>

                            <div className={style.buttonSection} style={{paddingTop: "2%", paddingBottom: '2%'}}>
                                <button
                                    className="buttonCss"
                                    onClick={onSubmit}>
                                    Publish
                                </button>
                                <button
                                    className="closeButtonCss"
                                    onClick={() => navigate('/document-config', {state: {tab: 1}})}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </BoxComponent>
            </form>
        </div>
    );
};

export default NewDocument;
